import { css, html } from "../helpers/webComponents";

const styles: string = css`
     :host {
        height: 100%;
        display: flex;
        background-color: rgba(0, 0, 0, 0.75);
        justify-content: center;
        align-items: center;
     }
`;

export class ModalLeaderboardComponent extends HTMLElement {
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const element: HTMLElement = this.renderLeaderboard();

        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(element);
    }

    private renderLeaderboard(): HTMLElement {
        const element: HTMLElement = html`
             <div>
                 <style>
                    ${styles}
                 </style>

                 <div>
                    <leaderboard-component></leaderboard-component>
                 </div>
             </div>
        `;
        return element;
    }
}
